import { forwardRef } from 'react';
import { useRef } from 'react';

import { MobileUserEnteringPage } from './MobileUserEnteringPage';
import { UserEnteringProps } from './types';

export const MobileUserEnteringPageContainer = forwardRef<HTMLDivElement, UserEnteringProps>(({
  error,
  textInput,
  onTextInputChange,
  handlePayButtonClick,
  handleUserSearchButton,
}) => {

  const afterUserChooseRef = useRef<HTMLDivElement>(null);

  return (
    <MobileUserEnteringPage
      error={error}
      textInput={textInput}
      onTextInputChange={onTextInputChange}
      handleUserSearchButton={handleUserSearchButton}
      delayAnimation={0.2}
      ref={afterUserChooseRef}
      handlePayButtonClick={handlePayButtonClick}
    />
  );
});

export default  MobileUserEnteringPageContainer;
